import axios from "axios";

const API = axios.create({
  // Local development - Firebase emulator
   baseURL: "https://api-zfirhwg2rq-uc.a.run.app",
  // Production
  //  baseURL: "http://127.0.0.1:5001/adira-logistics/us-central1/api",
});

// Attach token to headers for every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle response errors (like token expiration)
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token is invalid or expired
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect to login page
      window.location.href = '/adira';
    }
    return Promise.reject(error);
  }
);

export default API;
